module.exports = __webpack_public_path__ + "media/images/athletes/1790-c3049fc5c59bc8401a8f2202b0665ecd.png";